  {{#if (hasAny entity 'precedingPlaceOrGeographicName' 'succeedingPlaceOrGeographicName' 'temporaryNameOfThePlaceOrGeographicName')}}
  <tr class="gnd-infobox-temporary-names">
    <th>Zeitweise Namen:</th>
    <td>
      <dl>
        {{#with entity.precedingPlaceOrGeographicName}}
        {{#each (arrayify this) as |preceding|}}
        <dd>
          <a href="{{hrefGnd preceding.[@id]}}">{{preferredName preceding}}</a>
        </dd>
        {{/each}}
        {{/with}}
        {{#with entity.succeedingPlaceOrGeographicName}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/with}}
        {{#with entity.temporaryNameOfThePlaceOrGeographicName}}
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>
        {{/with}}        
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if (getGeometry entity)}}
  <tr class="gnd-infobox-geometry">
    <th>Koordinaten:</th>
    <td>
      <dl>
        <dd>{{getGeometry entity}}</dd>
      </dl>
    </td>
  </tr>
  {{/if}}  
  {{#if entity.geographicAreaCode}}
  <tr class="gnd-infobox-geographic-area-code">
    <th>Land:</th>
    <td>
      <dl>
        {{#each (arrayify entity.geographicAreaCode) as |ac|}}
        <dd>
          {{prefLabelInGraph ac.[@id] 'gnd-ac'}}
        </dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#if entity.broaderTermPartitive}}  
  <tr class="gnd-infobox-broader-term-partitive">
    <th>Verwaltungseinheit:</th>
    <td>
      <dl>
        {{#each (arrayify entity.broaderTermPartitive) as |subentity|}}
        <dd>
          <a href="{{hrefGnd subentity.[@id]}}">{{preferredName subentity}}</a>
        </dd>
        {{/each}}        
      </dl>
    </td>
  </tr>
  {{/if}}
  {{#with entity.hierarchicalSuperiorOfPlaceOrGeographicName}}  
  <tr class="gnd-infobox-hierarchical-superior">
    <th>Geografischer Bezug:</th>
    <td>
      <dl>        
        <dd>
          <a href="{{hrefGnd [@id]}}">{{preferredName this}}</a>
        </dd>        
      </dl>
    </td>
  </tr>
  {{/with}}
  {{#if (prop entity 'biographicalOrHistoricalInformation') }}
  <tr class="gnd-infobox-biographical-or-historical-information">
    <th>Weitere Angaben:</th>
    <td>
      <dl>
        <dd >{{ prop entity 'biographicalOrHistoricalInformation' }}</dd>
      </dl>      
    </td>
  </tr>  
  {{/if}}
  {{#if entity.dateOfEstablishment }}
  <tr class="gnd-infobox-date-of-establishment">
    <th>Gründung:</th>
    <td>{{ entity.dateOfEstablishment }}</td>
  </tr>
  {{/if}}
  {{#if entity.owl:sameAs }}
  <tr class="gnd-infobox-same-as">
    <th>Gleichwertige Konzepte:</th>
    <td>
      <dl>
          {{#each (arrayify entity.owl:sameAs) as |subentity| }}
          <dd><a href="{{hrefGnd subentity.[@id]}}">{{hrefGnd subentity.[@id]}}</a></dd>
          {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}

  {{#if (variantName entity) }}
  <tr class="gnd-infobox-variant-names">
    <th>Varianten:</th>
    <td>
      <dl>
        {{#each (arrayify (variantName entity)) as |name|}}
        <dd class="gnd-infobox-variant-name">{{ name }}</dd>
        {{/each}}
      </dl>
    </td>
  </tr>
  {{/if}}
